import React from "react";
import { Wrapper, Title, Description } from "./styled";
import { Color } from "../../../settings";
import { Container } from "../Container/styled";

interface PageHeaderProps {
  title: string;
  description: string;
  color?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
  textAlign?: "center" | "left";
}

const PageHeader = ({
  title,
  description,
  color,
  backgroundColor,
  children,
  textAlign = "left",
}: PageHeaderProps) => {
  const theme = {
    color: !!color ? color : Color.black,
    backgroundColor: !!backgroundColor ? backgroundColor : "transparent",
  };

  return (
    <Wrapper theme={theme} style={{ textAlign }}>
      <Container size="small">
        <Title>{title}</Title>
        {!!description && <Description>{description}</Description>}
        {!!children && children}
      </Container>
    </Wrapper>
  );
};

export default PageHeader;
